import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { VoucherService } from "../../../accounts/voucher/shared/voucher.service";

@Injectable({
  providedIn: 'root'
})
export class PrintledgerService {

  constructor( private datePipe: DatePipe,
  private  voucherService : VoucherService) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  GenerateReport(rptSearchData: any) {

    this.voucherService.FetchLedgerReports(rptSearchData)
    .toPromise()
    .then(data => {
      
      this.ReportGenerateList(data, rptSearchData, this.datePipe);
      // this.ReportGenerateListHtml(data, rptSearchData, this.datePipe);
    })
    .catch(err => { console.log(err) });
  }

  //--------------------------------------------------  
  
  ReportGenerateList(VoucherData : any, searchDate: any,datePipe: DatePipe) {

    function createHeaders(HeaderName) {

      var HeaderResult = [];
      for (var i = 0; i < HeaderName.length; i += 1) {
        if(i==0){
            HeaderResult.push({
              id: HeaderName[i],
              name: HeaderName[i],
              prompt: HeaderName[i],
              width: "90",
              align: "left",
              padding: 0,});}
        else if(i==1){
                HeaderResult.push({
                  id: HeaderName[i],
                  name: HeaderName[i],
                  prompt: HeaderName[i],
                  width: "190",
                  align: "left",
                  padding: 0,});}
        else if(i==2){
            HeaderResult.push({
              id: HeaderName[i],
              name: HeaderName[i],
              prompt: HeaderName[i],
              width: "100",
              align: "left",
              padding: 0,
        });}
        else if(i==3){
          HeaderResult.push({
            id: HeaderName[i],
            name: HeaderName[i],
            prompt: HeaderName[i],
            width: "80",
            align: "right",
            padding: 0,
      });}
      else if(i==4 || i==5){
            HeaderResult.push({
              id: HeaderName[i],
              name: HeaderName[i],
              prompt: HeaderName[i],
              width: "80",
              align: "right",
              padding: 0,});}
      else{
            HeaderResult.push({
              id: HeaderName[i],
              name: HeaderName[i],
              prompt: HeaderName[i],
              width: "140",
              align: "left",
              padding: 0,});
          }
      }

    return HeaderResult;
    }

  var headers = createHeaders([
    "Date",
    "Ledger",
    "Type",
    "Debit",
    "Credit",
    "Balance",
    "Branch"
  ]);

  // Document of 210mm wide and 297mm high
  let pdf = new jsPDF('p', 'pt', 'A4');

  pdf.setProperties({
    title: 'Ledger',
    subject: 'Info about PDF',
    author: 'PDFAuthor',
    keywords: 'generated, javascript, web 2.0, ajax',
    creator: 'SRI'
  });

  let todayDate = new Date();

  // Top HEADER
  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(14);
  pdf.setFont('arial', 'normal');
  pdf.text("Society For Rural Improvements", 210, 40);  // 40 is the height
  pdf.text("Ledger Report Between " + 
  datePipe.transform(searchDate.LedgerFromDate, 'dd-MM-yyyy').toString()
   + " and " +  
  datePipe.transform(searchDate.LedgerToDate, 'dd-MM-yyyy').toString(), 160, 60);
  pdf.setLineWidth(1);
  pdf.line(5, 70, 590, 70)
  // Top HEADER END 

  // Second Top HEADER
  pdf.setFontSize(8);   

  var generateData = function (VoucherData) {

    var result = [];
    var itemData = [{}];     
    let voucherName :string;

    for (var i = 0; i < VoucherData.length; i += 1) {

          itemData[i] = {
            Id: VoucherData[i].Id.toString(),
            'Date': datePipe.transform(VoucherData[i].CreatedDate, 'dd-MM-yyyy').toString(),
            'Ledger': VoucherData[i].LedgerName.toString(),
            'Type': VoucherData[i].Name.toString(),
            'Debit': VoucherData[i].EntryType == "D " ? (VoucherData[i].DebitAmount.toString()) : "0.00",
            'Credit': VoucherData[i].EntryType == "C " ? (VoucherData[i].CreditAmount.toString()) : "0.00",
            'Balance': VoucherData[i].Balance.toString(),
            'Branch':  VoucherData[i].CustomerBranchName.toString(),
          }
        }

    for (var i = 0; i < VoucherData.length; i += 1) {
      itemData[i]['Id'] = (i + 1).toString();
      result.push(Object.assign({}, itemData[i]));
    }
    return result;
  };

  pdf.table(5, 80,generateData(VoucherData), headers, { autoSize: false });
  // pdf.output('dataurlnewwindow');

  pdf.save("LedgerReport.pdf");

}

}
